import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IGetIndirectTaxCredentialParams,
  IGetIndirectTaxCredentialResponse,
} from './types';

export function useIndirectTaxCredential(
  credentialId: string | null,
  params: IGetIndirectTaxCredentialParams | null,
  token?: string
) {
  const queryParams = params
    ? new URLSearchParams({
        corporationId: params.corporationId.toString(),
      }).toString()
    : '';

  const { data, mutate, error, isLoading } =
    useSWR<IGetIndirectTaxCredentialResponse>(
      credentialId && params
        ? `new-sales-tax/credentials/${credentialId}?${queryParams}`
        : null,
      SWRFetcher({ method: 'GET' }, token)
    );

  return {
    data: data?.credential,
    mutate,
    error,
    isLoading,
  };
}
